import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const voices = [
  {
    img: "/images/stimme-1.webp",
    alt: "Porträt einer Kundin vor ihrem Einfamilienhaus mit Solaranlage",
    quote:
      "Die Beratung war ehrlich und kompetent, die Installation sauber und der Wechselrichter läuft seit drei Jahren ohne einen einzigen Ausfall. Klare Empfehlung.",
    name: "Regula Müller",
    role: "Einfamilienhaus, Winterthur",
    meta: "12.8 kWp + 10 kWh Speicher",
  },
  {
    img: "/images/stimme-2.webp",
    alt: "Porträt eines Landwirts vor seinem Ökonomiegebäude",
    quote:
      "Vom ersten Termin bis zur Inbetriebnahme hatte ich denselben Ansprechpartner. Die Scheune produziert heute mehr Strom, als der ganze Betrieb braucht.",
    name: "Hans Baumgartner",
    role: "Landwirtschaftsbetrieb, Thurgau",
    meta: "180 kWp, eigenverbrauchsoptimiert",
  },
  {
    img: "/images/stimme-3.webp",
    alt: "Porträt einer Geschäftsführerin vor ihrem Firmengebäude",
    quote:
      "Termine wurden eingehalten, das Budget auch. Für uns als Betrieb war entscheidend, dass die Montage ohne Produktionsunterbruch lief – hat funktioniert.",
    name: "Céline Perret",
    role: "Geschäftsleitung, Aargau",
    meta: "240 kWp Gewerbedach",
  },
];

export default function Testimonials() {
  return (
    <section
      id="stimmen"
      data-testid="testimonials-section"
      className="relative py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-12">
          <div className="lg:col-span-7">
            <div className="text-sm text-[#EAB308] font-semibold uppercase tracking-widest">
              Kundenstimmen
            </div>
            <h2 className="mt-3 font-display font-semibold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1A1D20]">
              Was unsere Kundinnen
              <span className="text-[#4B5563]"> und Kunden sagen.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:text-right">
            <div className="inline-flex items-center gap-3 rounded-full border border-black/5 bg-white px-4 py-2.5">
              <span className="flex" aria-hidden="true">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} size={16} className="text-[#EAB308] fill-[#EAB308]" />
                ))}
              </span>
              <span className="text-sm text-[#1A1D20]">
                <strong className="font-semibold">4.9 / 5</strong>
                <span className="text-[#4B5563]"> aus 312 Bewertungen</span>
              </span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {voices.map((v, i) => (
            <motion.figure
              key={v.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`testimonial-${i}`}
              className="card-lift relative flex flex-col rounded-2xl border border-black/5 bg-white p-6 md:p-7"
            >
              <Quote
                size={28}
                className="text-[#EAB308] shrink-0"
                aria-hidden="true"
              />

              <blockquote className="mt-4 flex-1 text-[#1A1D20]/85 leading-relaxed">
                {v.quote}
              </blockquote>

              <figcaption className="mt-6 pt-5 border-t border-black/5 flex items-center gap-3.5">
                <img
                  src={v.img}
                  alt={v.alt}
                  width="512"
                  height="512"
                  loading="lazy"
                  decoding="async"
                  className="w-12 h-12 rounded-full object-cover img-placeholder shrink-0"
                />
                <div className="min-w-0">
                  <div className="font-display font-semibold text-[#1A1D20] leading-tight">
                    {v.name}
                  </div>
                  <div className="text-sm text-[#4B5563] truncate">{v.role}</div>
                  <div className="text-xs text-[#EAB308] font-medium mt-0.5">
                    {v.meta}
                  </div>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
